import { useTranslate } from 'module/hooks/use-translation';
import { SourcePageTemplate } from 'api/custom-section/types';
import {
  AveragePerCharacterWidth,
  listIntoSentence,
} from 'helpers/list-into-sentence';
import { useEffect, useRef, useState } from 'react';

export const useSourceIntoText = (sourceTemplates: SourcePageTemplate[]) => {
  const translate = useTranslate();

  const [sourceToDisplay, setSourceToDisplay] = useState('');
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (wrapperRef.current) {
      const wrapperWidth = wrapperRef.current.offsetWidth;
      const availableWidth = wrapperWidth * 0.6;
      const maxChars = Math.floor(availableWidth / AveragePerCharacterWidth);
      const sources = sourceTemplates.map(({ templateName }) => templateName);

      setSourceToDisplay(
        listIntoSentence({
          list: sources ?? [],
          separator: ', ',
          andSeparator: ` ${translate('and')} `,
          maximumNumberOfCharactersAllowed: maxChars,
          moreConstructor: (count) =>
            translate(
              'rich_text_editor.sections.company_page_source_derived_section.sources.label.more_sources',
              { count },
            ),
        }),
      );
    }
  }, [translate, sourceTemplates]);

  return {
    sourceToDisplay,
    wrapperRef,
  };
};
